import { AuthContext, type AuthContextProps } from "@/contexts/auth/Auth";
import { useContext } from "react";

export const useAuth = () => {
  const context = useContext(AuthContext) as AuthContextProps;

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }

  return context;
}